var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Button, DynamicSvg, InfoTag, Typography, getTestId, tokens } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getUpsellSubsectionStyles } from './UpsellSubsectionStyles';
export var UpsellSubsection = props => {
  var subSection = props.subSection,
    _props$subSectionNumb = props.subSectionNumberOfLines,
    subSectionNumberOfLines = _props$subSectionNumb === void 0 ? 1 : _props$subSectionNumb,
    _props$isBoldSubsecti = props.isBoldSubsection,
    isBoldSubsection = _props$isBoldSubsecti === void 0 ? false : _props$isBoldSubsecti,
    iconName = props.iconName,
    iconColorToken = props.iconColorToken,
    isMobileScreen = props.isMobileScreen,
    subSectionColor = props.subSectionColor,
    isSubSectionStrikeOut = props.isSubSectionStrikeOut,
    _props$subSectionAlig = props.subSectionAlignment,
    subSectionAlignment = _props$subSectionAlig === void 0 ? 'center' : _props$subSectionAlig,
    infoTagModel = props.infoTagModel,
    subSectionCtaText = props.subSectionCtaText,
    subSectionCtaProps = props.subSectionCtaProps,
    subSectionCtaPressMetaData = props.subSectionCtaPressMetaData,
    _props$subSectionAcce = props.subSectionAccessibilityProps,
    subSectionAccessibilityProps = _props$subSectionAcce === void 0 ? {} : _props$subSectionAcce,
    _props$iconAccessibil = props.iconAccessibilityProps,
    iconAccessibilityProps = _props$iconAccessibil === void 0 ? {} : _props$iconAccessibil,
    style = props.style,
    id = props.id,
    testID = props.testID,
    onUserAction = props.onUserAction,
    subText = props.subText,
    _props$subTextAlignme = props.subTextAlignment,
    subTextAlignment = _props$subTextAlignme === void 0 ? 'center' : _props$subTextAlignme,
    _props$subTextColor = props.subTextColor,
    subTextColor = _props$subTextColor === void 0 ? BLACK_700 : _props$subTextColor,
    _props$subTextNumberO = props.subTextNumberOfLines,
    subTextNumberOfLines = _props$subTextNumberO === void 0 ? 2 : _props$subTextNumberO,
    _props$subTextAccessi = props.subTextAccessibilityProps,
    subTextAccessibilityProps = _props$subTextAccessi === void 0 ? {} : _props$subTextAccessi,
    restProps = __rest(props, ["subSection", "subSectionNumberOfLines", "isBoldSubsection", "iconName", "iconColorToken", "isMobileScreen", "subSectionColor", "isSubSectionStrikeOut", "subSectionAlignment", "infoTagModel", "subSectionCtaText", "subSectionCtaProps", "subSectionCtaPressMetaData", "subSectionAccessibilityProps", "iconAccessibilityProps", "style", "id", "testID", "onUserAction", "subText", "subTextAlignment", "subTextColor", "subTextNumberOfLines", "subTextAccessibilityProps"]);
  var upsellTitleStyles = getUpsellSubsectionStyles();
  return _jsxs(View, Object.assign({}, getTestId(testID, 'UpsellSubSection_Container'), {
    style: [upsellTitleStyles.container, style]
  }, restProps, {
    children: [!!subSection && _jsx(Typography, Object.assign({
      text: subSection,
      type: isMobileScreen ? "body-para-sm" + (isBoldSubsection ? '-bold' : '') : "body-para-md" + (isBoldSubsection ? '-bold' : ''),
      numberOfLines: subSectionNumberOfLines,
      color: subSectionColor,
      textAlignment: subSectionAlignment,
      isStriked: isSubSectionStrikeOut
    }, getTestId(testID, 'subSection'), subSectionAccessibilityProps)), !!(infoTagModel === null || infoTagModel === void 0 ? void 0 : infoTagModel.infoTagText) && _jsx(InfoTag, Object.assign({
      text: infoTagModel === null || infoTagModel === void 0 ? void 0 : infoTagModel.infoTagText,
      subType: infoTagModel === null || infoTagModel === void 0 ? void 0 : infoTagModel.infoTagType,
      size: isMobileScreen ? 'sm' : 'md',
      style: upsellTitleStyles.infoTagStyle
    }, getTestId(testID, 'infoTag')), "infoTag-" + (infoTagModel === null || infoTagModel === void 0 ? void 0 : infoTagModel.infoTagText)), !!iconName && _jsx(DynamicSvg, Object.assign({
      iconName: iconName,
      fontSize: isMobileScreen ? tokens.spacing.SPACING_24 : tokens.spacing.SPACING_32,
      color: iconColorToken
    }, getTestId(testID, 'icon'), iconAccessibilityProps)), !!subText && _jsx(Typography, Object.assign({
      text: subText,
      type: isMobileScreen ? 'body-para-sm' : 'body-para-md',
      numberOfLines: subTextNumberOfLines,
      color: subTextColor,
      textAlignment: subTextAlignment,
      style: upsellTitleStyles.subTextStyle
    }, getTestId(testID, 'subText'), subTextAccessibilityProps)), !!subSectionCtaText && _jsx(Button, Object.assign({
      title: subSectionCtaText,
      buttonType: "tertiary",
      style: upsellTitleStyles.ctaStyle,
      onPress: () => {
        subSectionCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, subSectionCtaPressMetaData), {
          item: props
        }));
      }
    }, subSectionCtaProps, getTestId(testID, 'subSectionCta')))]
  }));
};